import { h } from 'preact';
import React, { Component } from 'react';

import SpecialPurposes from '../SpecialPurposes/SpecialPurposes';
import Features from '../Features/Features';
import Accordion from '../Components/Accordion';
import PurposeContent from '../Purposes/PurposeContent';
import FeatureContent from '../Features/FeatureContent';
import StackToggle from '../Stacks/StackToggle';
import { StackTitle } from '../Stacks/StackTitle';
import { makeText } from '../../../util';

const StackContent = ({
  stack,
  selected,
  settings,
  togglePurposeOrFeature,
  toggleText,
  toggleOffText,
  force,
  updateMe,
  accordionOpen
}) => {
  return (
    <div className="purpose-content">
      <p style={{ ...settings.panelFont }} className="stack-description">{stack.description}</p>
      {stack.categories.map(c => (
        <StackToggle
          key={c._id}
          purpose={c}
          selected={selected}
          settings={settings}
          togglePurposeOrFeature={togglePurposeOrFeature}
          toggleText={toggleText}
          toggleOffText={toggleOffText}
          force={force}
          updateMe={updateMe}
          parentAccordionOpen={accordionOpen}
        />
      ))}
    </div>
  );
};

export default class Stacks extends Component {
  state = {
    forceUpdate: true
  }
  force = () => this.setState({ forceUpdate: !this.state.forceUpdate })
  render() {
    const {
      stacks,
      useStacks,
      consentOnlyStacks,
      purposes,
      specialPurposes,
      specialFeatures,
      features,
      settings,
      language,
      selected,
      dev,
      usePurModel,
    } = this.props;

    const toggleText = makeText(Boolean(dev), settings, 'toggleText', language);
    const toggleOffText = makeText(Boolean(dev), settings, 'toggleOffText', language);
    const customPurposesLetter = makeText(Boolean(dev), settings, 'customPurposesLetter', language);

    /* GATHER STACKS */
    const stacksWithPurposes = stacks
      .filter(s => s.childCategories.length > 0)
      .map(s => {
        s.categories = s.childCategories.map(c => purposes.find(j => j._id === c)).filter(h => {
          if (h === undefined) return false;
          if (selected === 'consent' && h.requiringConsentVendors.length <= 0) return false;
          if (selected === 'li' && h.legIntVendors.length <= 0) return false;
          return true;
        });
        return s;
      });
    let foundPurposes = [];
    stacksWithPurposes.forEach(s => {
      const catIds = s.categories.map(c => c._id);
      foundPurposes = [...foundPurposes, ...catIds];
    });

    /* GATHER PURPOSES */
    const actuallyUseStacks = selected === 'li' && consentOnlyStacks ? false : useStacks;
    const disclosureOnlyPurposes = [];
    let purposeOne = null;
    const actualPurposes = purposes.filter(p => {
      if (p.disclosureOnly === true) {
        disclosureOnlyPurposes.push(p);
        return false;
      }
      if (selected === 'consent' && p.requiringConsentVendors.length <= 0) return false;
      if (selected === 'li' && p.legIntVendors.length <= 0) return false;
      if (actuallyUseStacks && p.iabId === 1) {
        purposeOne = p;
        return false;
      }
      if (actuallyUseStacks && foundPurposes.find(fp => fp === p._id)) return false;
      return true;
    });
    return (
      <div className="pm-main">
        {actuallyUseStacks === true && (
          <div className="type-box">
            { /* 1. LIST OUT PURPOSE ONE */}
            {purposeOne !== null && (
              <Accordion
                key={`purpose-${purposeOne._id}`}
                settings={settings}
                name={<span>{purposeOne.name}{purposeOne.type !== 'IAB_PURPOSE' && <span className="legend-key inline">{customPurposesLetter}</span>}</span>}
                description={purposeOne.description}
                child="purposes"
                language={language}
                value={purposeOne}
                selected={selected}
                vendors={selected === 'consent' ? purposeOne.requiringConsentVendors : purposeOne.legIntVendors}
                content={<PurposeContent dev={dev} selected={selected} purpose={purposeOne} language={language} settings={settings} force={this.force} isCustom={purposeOne.type === 'CUSTOM'} />}
                toggle={this.props.togglePurposeOrFeature}
                updateMe={this.state.forceUpdate}
                dev={dev}
                usePurModel={usePurModel}
              />
            )}

            { /* 2. LIST OUT ALL STACKS */}
            {stacksWithPurposes.length > 0 && stacksWithPurposes.map(s => s.categories.length > 0 ? (
              <Accordion
                key={`stack-${s._id}`}
                settings={settings}
                child="purposes"
                language={language}
                value={s}
                titleContent={<StackTitle stack={s} selected={selected} toggleStack={this.props.toggleStack} language={language} settings={settings} dev={dev} />}
                content={<StackContent stack={s} selected={selected} settings={settings} togglePurposeOrFeature={this.props.togglePurposeOrFeature} toggleText={toggleText} toggleOffText={toggleOffText} language={language} force={this.force} updateMe={this.state.forceUpdate} dev={dev} isCustom={s.type === 'CUSTOM'} />}
                toggle={false}
                force={this.force}
                updateMe={this.state.forceUpdate}
                dev={dev}
                usePurModel={usePurModel}
              />
            ) : null)}
          </div>
        )}

        { /* 3. PURPOSES THAT DO NOT FALL UNDER STACKS */}
        <div className={actualPurposes && actualPurposes.length > 0 ? 'type-box' : ''}>
          {actualPurposes.map(p => (
            <Accordion
              key={`purpose-${p._id}`}
              settings={settings}
              name={<span>{p.name}{p.type !== 'IAB_PURPOSE' && <span className="legend-key inline">{customPurposesLetter}</span>}</span>}
              description={p.description}
              child="purposes"
              language={language}
              value={p}
              selected={selected}
              vendors={selected === 'consent' ? p.requiringConsentVendors : p.legIntVendors}
              content={<PurposeContent selected={selected} purpose={p} language={language} settings={settings} force={this.force} dev={dev} isCustom={p.type === 'CUSTOM'} />}
              toggle={this.props.togglePurposeOrFeature}
              updateMe={this.state.forceUpdate}
              dev={dev}
              usePurModel={usePurModel}
            />
          ))}
        </div>

        { /* 4. SPECIAL FEATURES WHICH HAVE TOGGLE ABILITY */}
        {selected === 'consent' && specialFeatures.length > 0 && (
          <div className="type-box">
            {specialFeatures.map(f => (
              <Accordion
                key={`special-purpose-${f._id}`}
                settings={settings}
                name={f.name}
                child="features"
                language={language}
                value={f}
                vendors={f.vendors}
                description={f.description}
                content={<FeatureContent selected={selected} feature={f} language={language} settings={settings} force={this.force} dev={dev} isCustom={f.type === 'CUSTOM'} />}
                toggle={this.props.togglePurposeOrFeature}
                dev={dev}
                usePurModel={usePurModel}
              />
            ))}
          </div>
        )}

        { /* 5. REGULAR FEATURES WHICH HAVE TOGGLE ABILITY */}
        {selected === 'consent' && (specialPurposes.length > 0 || disclosureOnlyPurposes.length > 0) && (
          <div className="type-box">
            <SpecialPurposes
              dev={dev}
              specialPurposes={specialPurposes}
              disclosureOnlyPurposes={disclosureOnlyPurposes}
              language={language}
              settings={settings}
              force={this.force}
              updateMe={this.state.forceUpdate}
              usePurModel={usePurModel}
            />
          </div>
        )}
        { /* 5. REGULAR FEATURES WHICH HAVE TOGGLE ABILITY */}
        {selected === 'consent' && features.length > 0 && (
          <div className="type-box">
            <Features
              dev={dev}
              features={features}
              language={language}
              settings={settings}
              force={this.force}
              updateMe={this.state.forceUpdate}
              usePurModel={usePurModel}
            />
          </div>
        )}
      </div>
    );
  }
}
